import { useDispatch, useSelector } from "react-redux";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import { useEffect } from "react";
import {
  GetOneAcademicAchievement,
  SetAcademicAchievementState,
  UpdateAcademicAchievement,
} from "../../../Redux/Reducers/Submitter/AcademicAchievement";
import { useState } from "react";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { GetAllPublic_ST_TimePeriod } from "../../../Redux/Reducers/Shared/PublicTimePeriod";
import { useParams } from "react-router-dom";
import { upload } from "../../../Redux/Reducers/Shared/CompressAttachments";

const AcademicAchievement = (props) => {
  const [fileName, setFileName] = useState(null);
  const academicAchievement = useSelector(
    (state) => state.AcademicAchievement.AcademicAchievement
  );
  const { ApplicationInformationId } = useParams();
  const lang = useSelector((state) => state.languageReducer.Language);
  const ValidationWorkAndEducationInformationResultLsist = useSelector(
    (state) =>
      state.WorkAndEducationInformationValidation
        .ValidationWorkAndEducationInformation
  );

  const ValiationList =
    ValidationWorkAndEducationInformationResultLsist?.result?.map(
      (ele) => ele.code
    );

  const dispatch = useDispatch();

  const TimePeriod = useSelector(
    (state) => state.PublicTimePeriod.PublicTimePeriod
  );

  useEffect(() => {
    dispatch(
      GetAllPublic_ST_TimePeriod({
        academicAchievementShow: true,
        workExperiencePeriodFromYearShow: false,
        workExperiencePeriodToYearShow: false,
        volunteerCommunityWorkPeriodToYearShow: false,
        volunteerCommunityWorkPeriodFromYearShow: false,
        detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
      })
    );
    console.log(props.refreshDataFromClosePagePracticalExperiences, "ttttt");
  }, [
    props.refreshDataFromClosePagePracticalExperiences,
    props.refreshDataFromClosePageVoluntaryCommunityWork,
  ]);

  console.log(
    props.academicAchievement?.yearOfGraduation_TimePeriodId,
    "TimePeriodTimePeriod"
  );
  console.log(academicAchievement, "academicAchievementacademicAchievement");
console.log(ValiationList, "ValiationList");

  return (
    <div className="form-grid" style={{ marginBottom: "5px" }}>
      {academicAchievement?.academicAchievementId ? (
        <>
          <div style={{ marginTop: "10px" }}>
            <AttachmentASFH
              FileName={
                fileName == null
                  ? academicAchievement?.specializationCertificateAttachment
                  : fileName
              }
              FolderName={"AcademicAchievement"}
              show={true}
              disabled={props.disabled}
              clear={false}
              AttachementType="AcademicAchievement"
              readOnly={false}
              singleFile={
                academicAchievement?.specializationCertificateAttachment
              }
              onChange={async (e) => {
                // props.setSpecializationCertificateAttachment(e.target.files[0]);
                // console.log(academicAchievement, "academicAchievement");

                // var formData = new FormData();
                // formData.append("FolderName", "AcademicAchievement");
                // formData.append("file", e.target.files[0]);
                // var result = await dispatch(upload(formData));

                // var resultAfter = result.payload.fileName;

                // if (result.payload.fileName) {
                //   setFileName(resultAfter);
                //   console.log(
                //     {
                //       ...academicAchievement,
                //       SpecializationCertificateAttachment: resultAfter,
                //     },
                //     "aaaaaaaaadad"
                //   );
                //   dispatch(
                //     UpdateAcademicAchievement({
                //       AcademicAchievementId:
                //         academicAchievement?.academicAchievementId,
                //       SpecializationCertificateAttachment: resultAfter,
                //       YearOfGraduation_TimePeriodId:
                //         academicAchievement?.yearOfGraduation_TimePeriodId
                //           ? academicAchievement.yearOfGraduation_TimePeriodId
                //           : null,
                //       ApplicationInformationId:
                //         localStorage.getItem("ApplicationInformationId") ||
                //         ApplicationInformationId,
                //     })
                //   );
                // }

                const formData = new FormData();
                formData.append(
                  "AcademicAchievementId",
                  academicAchievement?.academicAchievementId
                );
                formData.append(
                  "SpecializationCertificateAttachment",
                  academicAchievement?.specializationCertificateAttachment
                );
                if (academicAchievement?.yearOfGraduation_TimePeriodId) {
                  formData.append(
                    "YearOfGraduation_TimePeriodId",
                    academicAchievement.yearOfGraduation_TimePeriodId
                  );
                }
                formData.append(
                  "ApplicationInformationId",
                  localStorage.getItem("ApplicationInformationId") ||
                    ApplicationInformationId
                );
                formData.append("file", e.target.files[0]);
                await dispatch(UpdateAcademicAchievement(formData));
              }}
              fieldsName={"SpecializationCertificate"}
              title="المرفقات"
              id="file-1"
              lang={lang}
              showValidationMessage={
                ValiationList?.includes("SpecializationCertificate")
                  ? true
                  : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
            />
          </div>
          <div style={{ marginTop: "-2px" }}>
            <AllDropDownsAHSF
              fieldsName="YearObtainingCertificate"
              showValidationMessage={
                ValiationList?.includes("YearObtainingCertificate")
                  ? true
                  : false
              }
              validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
              hidelable={false}
              disabled={props.disabled}
              //   labelName={"الجنسية"}
              lang={lang}
              show={true}
              valueEdite={academicAchievement?.yearOfGraduation_TimePeriodId}
              submissionStatus={"edite"}
              textEdite={academicAchievement?.timePeriodNumber}
              arrayOoptionList={TimePeriod}
              KeyText={lang === "ar" ? "timePeriodNumber" : "timePeriodNumber"}
              id={"timePeriodId"}
              dropdownType={"search"}
              defaultValue={academicAchievement?.yearOfGraduation_TimePeriodId}
              value={academicAchievement?.yearOfGraduation_TimePeriodId}
              OnClickLi={(e) => {
                // props.setYearObtainingCertificateId(e.timePeriodId);
                dispatch(
                  SetAcademicAchievementState({
                    ...academicAchievement,
                    yearOfGraduation_TimePeriodId: e.timePeriodId,
                  })
                );
              }}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default AcademicAchievement;
